import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M7 13.615c-.447 0-.829-.157-1.143-.472A1.557 1.557 0 0 1 5.385 12c0-.447.157-.829.472-1.143A1.557 1.557 0 0 1 7 10.385c.447 0 .829.157 1.143.472.315.315.472.696.472 1.143 0 .447-.157.829-.472 1.143A1.557 1.557 0 0 1 7 13.615M7 17.5c-1.526 0-2.824-.535-3.894-1.606C2.036 14.824 1.5 13.526 1.5 12c0-1.526.535-2.824 1.606-3.894C4.176 7.036 5.474 6.5 7 6.5c1.072 0 2.041.277 2.908.83a5.513 5.513 0 0 1 1.984 2.17h9.002l2.5 2.5-3.846 3.827-1.856-1.394-1.903 1.413-1.952-1.346h-1.945a5.567 5.567 0 0 1-1.984 2.165c-.867.557-1.836.835-2.908.835M7 16c.959 0 1.79-.29 2.491-.87.702-.579 1.16-1.289 1.374-2.13h3.443l1.44.996 1.954-1.429 1.698 1.298L21.265 12l-1-1h-9.4c-.214-.841-.672-1.551-1.374-2.13C8.79 8.29 7.96 8 7 8c-1.1 0-2.042.392-2.825 1.175C3.392 9.958 3 10.9 3 12s.392 2.042 1.175 2.825C4.958 15.608 5.9 16 7 16" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }